








































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {AugmentedLeg} from "./JourneySummary.vue";
import {CrsConverter} from "./CrsConverter";
import ModeIcon from "./ModeIcon.vue";

@Component({
    components: {ModeIcon}
})
export default class LegSummary extends Vue {
    @Prop() journey: Array<AugmentedLeg>;
    @Prop() crsConverter: CrsConverter;
    @Prop() label: string;

    legsShowingFull: Array<number> = [];

    private isShowingIntermediateStopsFor(leg: AugmentedLeg) {
        return this.legsShowingFull.includes(leg.legRecordID);
    }

    private hideIntermediates(leg: AugmentedLeg) {
        this.legsShowingFull = this.legsShowingFull.filter(l => leg.legRecordID !== l);
    }


    private indexToClassName(index: number, upperBound: number): string {
        if (index === 0) {
            return "line first";
        } else if (index === upperBound) {
            return "line last";
        }
        return "line peg";
    }

    private isIntermediate(index: number, upperBound: number): boolean {
        return !(index === 0 || index === upperBound);
    }

    private getTime(dt: string): string {
        const dateObj = new Date(dt);
        return this.checkTime(dateObj.getUTCHours()) + ":" + this.checkTime(dateObj.getUTCMinutes());
    }

    private checkTime(i: Number): string {
        if (i < 10) {
            return "0" + i.toString();
        }
        return i.toString();
    }

}
